import { Spin } from 'antd'
import { Logo } from 'assets'
import { typeUserConst } from 'constant'
import useAuth from 'hooks/useAuth'
import React, { Suspense } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import WhatsappButton from 'components/atoms/WhatsappButton'
import { ScrollToTop } from 'utils/ScrollToTop'

const BuySellLayout = () => {
  const { userType } = useAuth()
  const { pathname } = useLocation()
  if (userType === typeUserConst.UNDECIDED && !pathname.includes('subscription')) {
    return <Navigate to={'/onboarding'} replace={true} />
  }
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <header className="w-full py-4 px-4 lg:px-10 xl:px-[156px] sticky top-0 z-[200] bg-white flex justify-center lg:justify-between items-center">
        <Logo />
      </header>
      <main className="flex-grow flex min-h-0 flex-col">
        <Suspense
          fallback={
            <div
              className="
        flex flex-grow justify-center h-screen w-full items-center">
              <Spin size="large" spinning={true}></Spin>
            </div>
          }>
          <Outlet />
        </Suspense>
        <WhatsappButton />
      </main>
      <footer className="bg-surface-primary-3 py-4 flex justify-center items-center">
        <span className="text-primary text-sm">© 2025 TOMAZZ. All rights reserved.</span>
      </footer>
    </div>
  )
}

export default BuySellLayout
